<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="d-flex align-items-center mb-2" style="gap:10px;">
        <div class="section-title ">{{ $t("Customer Verification Logs") }}</div>

        <div class="px-2  w-25">
          <input
            v-model="searchLogs"
            :placeholder="$t('Search...')"
            class="form-control form-control-sm"
            type="search"
            v-on:input="onSearchLogs($event.target.value)"
            v-on:search="onSearchLogs($event.target.value)"
          />
        </div>
      </div>
      <div class="swc-report">
        <table border="1" class="swc-report-table mb-3">
          <thead>
          <tr>
            <th>{{ 'Verification ID' }}</th>
            <th>{{ 'OTP-SMS' }}</th>
            <th>{{ 'OTP-EMAIL' }}</th>
            <th>{{ 'User Detail' }}</th>
          </tr>
          </thead>

          <tbody>
          <tr
            v-for="(log, macsIndex) in logsData"
            :key="macsIndex"
            :style="!log.error ? '' : 'color:red'"
            class="light_grey_back"
          >
            <td class="padd">{{ log.verification_id }}</td>
            <td class="padd">{{ log.otp_sms }}</td>
            <td class="padd">{{ log.otp_email }}</td>
            <td class="padd" style="max-width: 550px; overflow: auto; white-space: normal">{{ log.user_detail }}</td>
          </tr>
          </tbody>

          <tbody v-if="logsData.length == 0">
          <tr>
            <td colspan="13">
              <NoRecords/>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import MarketingService from "@/services/MarketingService";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {DatePicker, Multiselect, NoRecords},
  data() {
    return {
      logsData: [],
      tempData: [],
      searchLogs: "",
      btenable: false,
      selectedFilterValue: "",
      filterValues: [],
      filterValuesCopy: [],
      searchFilterValues: "",
      isSearchLoading: false,
      filtervalue: "",
    };
  },
  beforeMount() {
    this.getAllCustomerVerification();
  },
  methods: {
    getAllCustomerVerification: function () {
      let loader = this.$loading.show();

      MarketingService.viewAllCustomerVerification()
      .then(response => {
        const {data} = response;

        if (data && data.status && data.Records.data.length > 0) {
          // data.Records.data.forEach(x => {
          //   x.emails = ([x.to, x.cc, x.bcc].filter(x => x).join(','))
          // })
          this.logsData = data.Records.data;
          this.tempData = data.Records.data;
        } else {
          console.log("data.message :", data.message);
        }
      })
      .finally(() => {
        loader.hide()
      });
    },
    onSearchLogs: function (value) {
      let search_value = String(this.searchLogs).toLowerCase();

      if (!search_value || search_value.length === 0) {
        this.logsData = this.tempData;
        return
      }

      let check_array = [
        "created_at",
        "verification_id",
        "user_detail",
        "otp_sms",
        "otp_email",
        "cust_id",
      ];

      this.logsData = this.tempData.filter(log => {
        let obj = {};
        let check = false;

        check_array.map(column => {
          if (typeof log[column] == "object") {
            obj[column] = JSON.stringify(log[column]).toLowerCase().includes(search_value);
          } else {
            obj[column] = String(log[column]).toLowerCase().includes(search_value);
          }

          if (!check && obj[column]) {
            check = true;
          }
        });

        return check;
      });
    }
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}

.icon-size {
  padding-top: 14px;
  padding-bottom: 14px;
  margin: auto;
}

td {
  text-align: left;
  padding: 0px;
}

.padd {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CustomersComponents/customers_verification.vue